<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.townDetails }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.townDetailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.title.$invalid && $v.title.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />

                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.zipCode.$invalid && $v.zipCode.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Zip kôd</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Zip kôd"
                        v-model="zipCode"
                      />
                      <form-error
                        :model="$v.zipCode"
                        :dirty="$v.$dirty"
                        label="Zip kôd"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger':
                        $v.dialingCode.$invalid && $v.dialingCode.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Pozivni broj</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Pozivni broj"
                        v-model="dialingCode"
                      />
                      <form-error
                        :model="$v.dialingCode"
                        :dirty="$v.$dirty"
                        label="Pozivni broj"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger':
                        $v.countryId.$invalid && $v.countryId.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Država
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="countryId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite državu"
                        :load-options="loadCountries"
                        :async="true"
                        :options="countries"
                        placeholder="Izaberite državu"
                      />

                      <form-error
                        :model="$v.countryId"
                        :dirty="$v.$dirty"
                        label="Država"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div
          class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
        >
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'Towns' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
// import { debounce } from 'lodash';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  components: {
    Treeselect,
    FormError,
  },
  name: 'AddTown',
  mixins: [translations],
  validations,
  data() {
    return {
      title: '',
      zipCode: '',
      dialingCode: '',
      countryId: null,
      countryTimerId: null,
    };
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  mounted() {
    this.$store.dispatch('getCountries', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { title, zipCode, dialingCode, countryId } = this;

      api
        .createTown({ zipCode, dialingCode, countryId, title })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Towns' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    loadCountries({ callback, searchQuery }) {
      console.log('loadCountries: ', this.countryTimerId, searchQuery);
      if(this.countryTimerId) clearTimeout(this.countryTimerId);

      this.countryTimerId = setTimeout(() => {
        this.$store
        .dispatch('getCountries', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.countries);
        });
      }, 750);
    },
  },
};
</script>
